export default {
  Web_name: "ลาวชนบท",
};
